/* unplugin-vue-components disabled */import script from "./schoolName.vue?vue&type=script&lang=ts&setup=true"
export * from "./schoolName.vue?vue&type=script&lang=ts&setup=true"

export default script